import React from "react";
import Button from "../../common/button/button";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import AlertIcon from "../../common/alertIcon/alertIcon";
import loadingSpinner from "../../assets/images/loading_spinner.gif";

export function BotaoCalcularAmpliacao({ calculoAmpliacao, event, aguardando }) {
    if (aguardando) {
        return (
            <Button
                style={{
                    height: 30,
                    width: 200,
                    margin: 2,
                    padding: 3,
                }}
                text={
                    <div className="d-flex justify-content-center align-items-center" style={{ fontSize: "0.65rem", lineHeight: "0.8rem" }}>
                        <div className="px-2">Carregando </div>
                        <img src={loadingSpinner} height={15} width={15} alt="" />
                    </div>
                }
                type={"info"}
                disabled={true}
            />
        );
    }

    const producao12Meses = calculoAmpliacao ? parseFloat(calculoAmpliacao.producao_ultimos_12_meses) || 0 : 0;
    const consumo12MesesFatura = calculoAmpliacao ? parseFloat(calculoAmpliacao.consumo_fatura_ultimos_12_meses) || 0 : 0;
    const consumo12MesesRemotas = calculoAmpliacao ? parseFloat(calculoAmpliacao.consumo_fatura_remota_ultimos_12_meses) || 0 : 0;
    const consumo12Meses = consumo12MesesFatura + consumo12MesesRemotas;
    const consumoInstantaneo12Meses = calculoAmpliacao ? parseFloat(calculoAmpliacao.consumo_instantaneo_fatura_ultimos_12_meses) || 0 : 0;
    const consumoSomado = consumoInstantaneo12Meses + consumo12Meses;
    const relacaoProducaoConsumo = consumoSomado ? (producao12Meses / consumoSomado) * 100 : 0;
    const diferencaProducao = producao12Meses - consumoSomado;

    return (
        <Button
            style={{
                height: 30,
                width: 200,
                margin: 2,
                padding: 3,
            }}
            text={
                <div style={{ fontSize: "0.65rem", lineHeight: "0.8rem" }}>
                    {calculoAmpliacao ? (
                        diferencaProducao < 0 ? (
                            <div title="Relação Produção baixa, clique para calcular sugestão de potência de ampliação">
                                <div>{`Calcular Ampliação`}</div>
                                <div className="d-flex justify-content-center align-props.items-center">
                                    {`Rel. P/C = ${adicionarPontosMilhar(relacaoProducaoConsumo)}%`}
                                    <AlertIcon width={10} height={10} animationClass={"alerta-triangulo-visualizado pl-2 pb-1"} title="" event={() => {}} />
                                </div>
                            </div>
                        ) : diferencaProducao >= 0 ? (
                            <div title="Relação Produção está suficiente, clique para verificar os detalhes">
                                <div>{`Produção Suficiente`}</div>
                                <div>
                                    {`Rel. P/C = ${adicionarPontosMilhar(relacaoProducaoConsumo)}%`}
                                    <i className="fas fa-check-circle ml-1" style={{ color: "green" }}></i>
                                </div>
                            </div>
                        ) : (
                            <div>{"Verificar Dados"}</div>
                        )
                    ) : (
                        <div title="Altere a coordenada padrão no cadastro da integração, pois a latitude e a longitude não estão definidas">{"Análise indisponível"}</div>
                    )}
                </div>
            }
            type={calculoAmpliacao ? (diferencaProducao >= 0 ? "success" : "info") : "danger"}
            disabled={!calculoAmpliacao}
            event={event}
        />
    );
}
